<template lang="pug">
.m-card
  .m-card-header(:id="'heading-hdpsl-' + childId" :data-bs-target="'#collapse-hdpsl-' + childId" :aria-controls="'collapse-hdpsl-' + childId" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ leagueName.trim() }}
  .m-card-body.collapse.show(:id="'collapse-hdpsl-' + childId" :aria-labelledby="'heading-hdpsl-' + childId" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper
          .m-label-wrap
            .m-label F.T    
          .odds-group
            .row
              template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
                OddsItem.col(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="1")
              template(v-else)
                OddsDisabled.col
              template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
                OddsItem.col(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="2")
              template(v-else)
                OddsDisabled.col



//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-hdpsl-' + childId"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-hdpsl-' + childId"
//-     :aria-controls="'collapse-hdpsl-' + childId"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-hdpsl-' + childId"
//-     :id="'collapse-hdpsl-' + childId"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .two-column
//-           //- .two-column-title {{ source }}
//-           .two-column-content
//-             .two-column-group
//-               .two-column-odd-area
//-                 .two-column-odd-area-oddtype
//-                   p.mb-0 {{ $t("m.ODD_Home") }}
//-                 .two-column-odd-area-group
//-                   template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
//-                     OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="1")
//-                   template(v-else)
//-                     OddsDisabled
//-             .two-column-group
//-               .two-column-odd-area
//-                 .two-column-odd-area-oddtype
//-                   p.mb-0 {{ $t("m.ODD_Away") }}
//-                 .two-column-odd-area-group
//-                   template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
//-                     OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="2")
//-                   template(v-else)
//-                     OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>
